import React from 'react';
import { confirmAlert } from 'react-confirm-alert';

import ConfirmPrompt from '../../General/ConfirmPrompt';

// The retire route refuses a longer reason.
const RETIREMENT_REASON_MAX = 280;

export const confirmRetire = ({ title, message, onRetire }) =>
  confirmAlert({
    customUI: ({ onClose }) => (
      <ConfirmPrompt
        header={title}
        subheader={message}
        isSingleLine
        requireInput
        maxLength={RETIREMENT_REASON_MAX}
        placeholder='Why is it being retired?'
        submitBtnDisplay='Retire'
        onCancel={onClose}
        onSubmit={reason => {
          onClose();
          onRetire(reason.trim());
        }}
      />
    )
  });
